import FilterDetailsList from './FilterDetailsList';

export default FilterDetailsList;
